import type { ReactElement, ReactNode } from 'react';
import type { FieldError as RHFFieldError } from 'react-hook-form';
import { FieldError } from './field-error.tsx';

export type FieldProps = {
    children?: ReactNode;
    error?: RHFFieldError;
    label?: ReactNode;
    required?: boolean;
};

export function Field({ children, error, label, required }: FieldProps): ReactElement {
    return (
        <label className="flex flex-col gap-2">
            <div className="select-none text-sm font-normal leading-none text-neutral-600 ">
                {label}
                {required ? ' *' : ''}
            </div>
            {children}
            <FieldError error={error} />
        </label>
    );
}
